import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=782390a4&scoped=true"
import script from "./SupplierManagement.vue?vue&type=script&lang=js"
export * from "./SupplierManagement.vue?vue&type=script&lang=js"
import style0 from "./SupplierManagement.vue?vue&type=style&index=0&id=782390a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782390a4",
  null
  
)

export default component.exports